<mat-card>
  <mat-card-header>
    <mat-card-title>
      <span>{{ '+SRC_COMMISSIONINGV2.ADD_COMPONENT_HEADER' | translate }}</span>
      <button mat-icon-button (click)="onCancel()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="content__body">
      <div class="content__description-section">
        <div class="description-section__header">
          {{ '+SRC_COMMISSIONINGV2.SELECT_HC_SUBTITLE' | translate }}
        </div>

        <mat-form-field
          mat-select-height-medium
          class="description-section__select"
          *ngIf="allCircuits | ready as circuits"
        >
          <mat-label>
            {{ '+COMMISSIONING.DEVICE_PANEL.HEATING_CIRCUIT.LABEL' | translate }}
          </mat-label>
          <mat-select [(ngModel)]="selectedChannel">
            <mat-option
              *ngFor="let circuit of circuits | featureValue: featurePropertyKey.enabled"
              [value]="circuit"
            >
              {{ installationService.getCircuitName(circuit) | async }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>

  <mat-card-actions>
    <button
      gtm="onPreviousStep"
      gtmAction="cancel"
      gtmCategory="assignChannelModal"
      mat-stroked-button
      color="primary"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      gtm="onNextStep"
      gtmAction="confirm step"
      gtmCategory="assignChannelModal"
      mat-raised-button
      color="primary"
      [disabled]="selectedChannel == null"
      (click)="onConfirm()"
    >
      {{ 'GENERAL.BUTTON.CONFIRM' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
